const CF_MONTH_MAP = {
  A: 1, B: 2, C: 3, D: 4, E: 5, H: 6,
  L: 7, M: 8, P: 9, R: 10, S: 11, T: 12
};

/**
 * Estrae la data di nascita da un codice fiscale italiano (formato standard).
 * @param {string} fiscalCode
 * @returns {string|null} Data in formato YYYY-MM-DD
 */
export const parseBirthDateFromFiscalCode = (fiscalCode) => {
  if (!fiscalCode || typeof fiscalCode !== 'string') return null;

  const cf = fiscalCode.trim().toUpperCase();
  if (!/^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/.test(cf)) {
    return null;
  }

  const yearPart = parseInt(cf.substring(6, 8), 10);
  const month = CF_MONTH_MAP[cf.charAt(8)];
  const dayRaw = parseInt(cf.substring(9, 11), 10);

  if (Number.isNaN(yearPart) || !month || Number.isNaN(dayRaw)) {
    return null;
  }

  const day = dayRaw > 40 ? dayRaw - 40 : dayRaw;
  if (day < 1 || day > 31) return null;

  const currentYear = new Date().getFullYear();
  const century = Math.floor(currentYear / 100) * 100;
  const currentYY = currentYear % 100;
  const fullYear = yearPart > currentYY ? century - 100 + yearPart : century + yearPart;

  const date = new Date(fullYear, month - 1, day);
  if (
    date.getFullYear() !== fullYear
    || date.getMonth() !== month - 1
    || date.getDate() !== day
  ) {
    return null;
  }

  const mm = String(month).padStart(2, '0');
  const dd = String(day).padStart(2, '0');
  return `${fullYear}-${mm}-${dd}`;
};

/**
 * Risolve la data di nascita da campi membro o, in fallback, dal codice fiscale.
 * @param {object} member
 * @returns {string|null}
 */
export const resolveMemberBirthDate = (member) => {
  const birthDateRaw = member?.birth_date
    || member?.data_nascita
    || member?.date_of_birth
    || member?.dob;

  if (birthDateRaw) {
    const parsed = new Date(birthDateRaw);
    if (!Number.isNaN(parsed.getTime())) {
      const y = parsed.getFullYear();
      const m = String(parsed.getMonth() + 1).padStart(2, '0');
      const d = String(parsed.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    }
  }

  return parseBirthDateFromFiscalCode(member?.fiscal_code);
};
